const ɵ0 = {
    n: 'id',
    t: 'number|string'
};
/** Account Definition */
export const AccountD = {
    recordTypeName: 'Account',
    id: ɵ0,
    name: {
        n: 'name',
        t: 'string'
    },
    label: {
        n: 'label',
        t: 'string'
    },
    description: {
        n: 'description',
        t: 'string'
    },
    isActive: {
        n: 'isActive',
        t: 'boolean',
        d: true
    },
    created: {
        n: 'created',
        t: 'number'
    },
    createdBy: {
        n: 'createdBy',
        t: 'TenantUserI'
    },
    createdById: {
        n: 'createdById',
        t: 'number|string'
    },
    updated: {
        n: 'updated',
        t: 'number'
    },
    updatedBy: {
        n: 'updatedBy',
        t: 'TenantUserI'
    },
    updatedById: {
        n: 'updatedById',
        t: 'number|string'
    },
    externalId: {
        n: 'externalId',
        t: 'string'
    },
    tenant: {
        n: 'tenant',
        t: 'TenantI'
    },
    tenantId: {
        n: 'tenantId',
        t: 'number|string'
    },
    owner: {
        n: 'owner',
        t: 'TenantUserI'
    },
    ownerId: {
        n: 'ownerId',
        t: 'number|string'
    },
    version: {
        n: 'version',
        t: 'number'
    },
    sfId: {
        n: 'sfId',
        t: 'string'
    },
    phone: {
        n: 'phone',
        t: 'string'
    },
    fax: {
        n: 'fax',
        t: 'string'
    },
    addrStreet: {
        n: 'addrStreet',
        t: 'string'
    },
    addrCity: {
        n: 'addrCity',
        t: 'string'
    },
    addrPostalCode: {
        n: 'addrPostalCode',
        t: 'string'
    },
    addrState: {
        n: 'addrState',
        t: 'string'
    },
    addrCountry: {
        n: 'addrCountry',
        t: 'string'
    },
    accountNumber: {
        n: 'accountNumber',
        t: 'string'
    },
    website: {
        n: 'website',
        t: 'string'
    },
    sic: {
        n: 'sic',
        t: 'string'
    },
    type: {
        n: 'type',
        t: 'string'
    },
    employees: {
        n: 'employees',
        t: 'number'
    },
    annualRevenue: {
        n: 'annualRevenue',
        t: 'number'
    },
    sfLastModifiedDate: {
        n: 'sfLastModifiedDate',
        t: 'number'
    },
}; // Account
export { ɵ0 };
